import React, { useState, useEffect } from 'react';
import { GetAuth } from '../../Auth/AuthProvider';
// import { NoHeaderTableUpdate } from '../../Helpers/requests';
import { r2_noHeaderTableUpdate } from '../../Helpers/r2_requests';

import UnauthorisedAccess from '../CommonComponents/UnauthorisedAccess';

import { convertDate } from '../../Helpers/helpers';

import { DataGrid } from '@mui/x-data-grid';
import { Box, Grid, Typography, Modal, Button } from '@mui/material';

import UsersAutocomplete from '../CommonComponents/UsersAutocomplete';
import TechAutocomplete from '../CommonComponents/TechAutocomplete';
import DatePicker from '../CommonComponents/DatePicker';

import TimeAndAttendanceEdit from './TimeAndAttendanceEdit';
import { Today } from '@mui/icons-material';

import ExportToCsv from '../../Helpers/CsvExport';
import { gridStyle } from './gridStyle';

import CircleIcon from '@mui/icons-material/Circle';

const TimeAndAttendance = () => {
  const [loggedData, setLoggedData] = useState([]);
  const [loggedPage, setLoggedPage] = useState(0);
  const [loggedPageSize, setLoggedPageSize] = useState(25);
  const [loggedSort, setLoggedSort] = useState([]);
  const [loggedFilter, setLoggedFilter] = useState([]);
  const [loggedTotalRows, setLoggedTotalRows] = useState(0);

  const [data, setData] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(1);

  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [filter, setFilter] = useState([]);
  const [sort, setSort] = useState([]);
  const [loading, setLoading] = useState(false);
  const enqNotification = GetAuth().Notification;
  const logout = GetAuth().signOut;
  const [updateData, setUpdateData] = useState(0);

  //FILTERS
  // const [techSelected, setTechSelected] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [fullFilterBlob, setFullFilterBlob] = useState([]);
  const [rangeFilterBlob, setRangeFilterBlob] = useState([]);
  const [useType, setUseType] = useState(localStorage.getItem('type'));
  const [rowData, setRowData] = useState({});

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setForceUpdate(forceUpdate + 1);
  };

  const handleFilterChange = (data, type) => {
    switch (type) {
      case 'tech_username':
        let oldData = [...fullFilterBlob];
        let tempData = oldData
          .slice()
          .filter((item) => item.field !== 'tech_username');

        data === '%'
          ? setFullFilterBlob([...tempData])
          : setFullFilterBlob([
              ...tempData,
              {
                field: 'tech_username',
                search: data,
                strict: true,
              },
            ]);
        break;
      default:
        // console.log(data);
        break;
    }
  };

  const padLeft = (intVal) => {
    return intVal < 10 ? `0${intVal}` : intVal;
  };

  const handleRangeChange = (data, type) => {
    let startTime = startDate;
    let endTime = endDate;
    let oldData = [...rangeFilterBlob];

    switch (type) {
      case 'start_time':
        startTime = data;

        let currentDate = new Date();
        let dateString = `${currentDate.getFullYear()}-${padLeft(
          currentDate.getMonth() + 1
        )}-${padLeft(currentDate.getDate())} 23:59:59`;

        let tempStartData = oldData
          .slice()
          .filter((item) => item.field !== 'start_time');

        data === '%'
          ? setRangeFilterBlob([...tempStartData])
          : setRangeFilterBlob([
              ...tempStartData,
              {
                field: 'start_time',
                start: data + ' 00:00:00',
                stop: dateString,
              },
            ]);
        setStartDate(data);
        break;
      case 'stop_time':
        endTime = data;
        let firstDate = new Date(0);

        let dateString1 = `${firstDate.getFullYear()}-${padLeft(
          firstDate.getMonth() + 1
        )}-${padLeft(firstDate.getDate())} 00:00:00`;

        let tempEndData = oldData
          .slice()
          .filter((item) => item.field !== 'stop_time');

        data === '%'
          ? setRangeFilterBlob([...tempEndData])
          : setRangeFilterBlob([
              ...tempEndData,
              {
                field: 'stop_time',
                start: dateString1,
                stop: data + ' 23:59:59',
              },
            ]);
        setEndDate(data);
        break;
      default:
        // console.log(data);
        break;
    }
  };

  const handelDate = (date, subVal) => {
    const inDate = date;
    // let outDate = inDate.substring(0, inDate.lastIndexOf('T') + 1);
    // outDate = outDate + subVal;
    // console.log(`Date: ${date} \nSubval: ${subVal} \nOutDate:`);
    return date;
  };

  const handleClearDateRange = () => {
    if (rangeFilterBlob.length > 0) {
      setRangeFilterBlob([]);
    }
  };

  useEffect(() => {
    const newDate = new Date();
    setStartDate(newDate);
    setEndDate(newDate);
  }, []);

  useEffect(
    () => {
      r2_noHeaderTableUpdate(
        {
          resource: `/api/r2_reports`,
          setDataFunc: setLoggedData,
          // pageNum: loggedPage,
          setLoadingFunc: setLoading,
          // pagesize: loggedPageSize,
          // sorting: loggedSort,
          // filtering: loggedFilter,
          // showNotification: enqNotification,
          setRows: setLoggedTotalRows,
          // logout,
        },
        'clocked_in'
      );
    },
    [
      // loggedPage,
      // loggedPageSize,
      // loggedSort,
      // loggedFilter,
      // updateData,
      // enqNotification,
      // logout,
      // fullFilterBlob,
      // rangeFilterBlob,
      // forceUpdate,
    ]
  );

  useEffect(() => {
    // console.log(fullFilterBlob);
    r2_noHeaderTableUpdate(
      {
        resource: `/api/r2_timelines`,
        setDataFunc: setData,
        pageNum: page,
        setLoadingFunc: setLoading,
        pagesize: pageSize,
        sorting: sort,
        filtering: filter,
        showNotification: enqNotification,
        setRows: setTotalRows,
        logout,
        fullFilters: fullFilterBlob,
        rangeFilters: rangeFilterBlob,
      },
      'r2_timelines'
    );
  }, [
    page,
    pageSize,
    sort,
    filter,
    updateData,
    enqNotification,
    logout,
    fullFilterBlob,
    rangeFilterBlob,
    forceUpdate,
  ]);

  const clockInDisplay = (value) => {
    switch (value) {
      case 'red':
        return 'Not Clocked In';
      case 'yellow':
        return 'Previous Clock In';
      case 'green':
        return 'Clocked In';

      default:
        break;
    }
  };

  const clockedInColumns = [
    // { field: 'date', headerName: 'Date', width: 150, flex: 1 },
    { field: 'username', headerName: 'User', width: 150, flex: 1 },
    {
      field: 'clock',
      headerName: 'Status',
      width: 150,
      flex: 1,
      // valueGetter: ({ value }) => clockInDisplay(value),
      renderCell: (data) => (
        <>
          <CircleIcon
            sx={{
              height: '55vh',
              maxWidth: '100%',
              textAlign: 'left',
              color: data.row.clock_in_status,
              // diffInDaysCSS(data.row.date_logged) === 'cold'
              //   ? 'green'
              //   : diffInDaysCSS(data.row.date_logged) === 'med'
              //   ? 'orange'
              //   : 'red',
            }}
          />
          <Typography variant='contained' size='small' marginLeft='5px'>
            {clockInDisplay(data.row.clock_in_status)}
          </Typography>
        </>
      ),
    },
    {
      field: 'last_clock_in',
      headerName: 'Last Clock-In',
      width: 150,
      flex: 1,
      renderCell: (data) => (
        <>
          <Typography variant='contained' size='small'>
            {data.row.last_clock_in === null || undefined
              ? ''
              : convertDate(
                  data.row.last_clock_in_override === null
                    ? data.row.last_clock_in
                    : data.row.last_clock_in_override,
                  0,
                  17
                )}
          </Typography>
        </>
      ),
    },
    {
      field: 'endTime',
      headerName: 'Last Clock-Out',
      width: 150,
      flex: 1,
      renderCell: (data) => (
        <>
          <Typography variant='contained' size='small'>
            {data.row.last_clock_out === null || undefined
              ? ''
              : convertDate(
                  data.row.last_clock_out_override === null
                    ? data.row.last_clock_out
                    : data.row.last_clock_out_override,
                  0,
                  17
                )}
          </Typography>
        </>
      ),
    },
  ];

  const formatTicketNumber = (data) => {
    const id = data.row.ticket_id;
    const ticketType =
      data.row.entry_type.toLowerCase() === 'repair_ticket' ? 'R' : 'I';

    if (!id) {
      return '';
    }

    const ticketNumber = id.toString().padStart(5, '0');
    return ticketType + ticketNumber;
  };

  const timeColumns = [
    // { field: 'date', headerName: 'Date', width: 150, flex: 1 },
    { field: 'tech_username', headerName: 'User', width: 150, flex: 1 },
    {
      field: 'tech_name',
      headerName: 'Name & Surname',
      width: 150,
      flex: 1,
      // renderCell: (data) => (
      //   <>{data.row.tech_name.trim() + ' ' + data.row.tech_surname.trim()}</>
      // ),
    },
    { field: 'tech_surname', headerName: 'Department', width: 150, flex: 1 }, //THis is Surname in the backend
    {
      field: 'entry_type',
      headerName: 'Type',
      width: 150,
      flex: 1,
      valueGetter: ({ value }) => ticketType(value),
    },
    {
      field: 'ticket_id',
      sortable: false,
      headerName: 'Ticket Number',
      flex: 1,
      renderCell: (data) => <>{formatTicketNumber(data)}</>,
    },
    {
      field: 'start_time',
      headerName: 'Start Time',
      width: 150,
      flex: 1,
      renderCell: (data) => (
        <>
          <Typography variant='contained' size='small'>
            {convertDate(
              data.row.start_time,

              0,
              17
            )}
          </Typography>
        </>
      ),
    },
    {
      field: 'stop_time',
      headerName: 'Stop Time',
      width: 150,
      flex: 1,
      renderCell: (data) => (
        <>
          <Typography variant='contained' size='small'>
            {data.row.stop_time === null || undefined
              ? 'Open'
              : convertDate(data.row.stop_time, 0, 17)}
          </Typography>
        </>
      ),
    },
    {
      field: 'start_time_override',
      headerName: 'Start Time Override',
      width: 150,
      flex: 1,
      renderCell: (data) => (
        <>
          <Typography variant='contained' size='small'>
            {data.row.start_time_override === null || undefined
              ? ''
              : convertDate(data.row.start_time_override, 0, 17)}
          </Typography>
        </>
      ),
    },
    {
      field: 'stop_time_override',
      headerName: 'Stop Time Overide',
      width: 150,
      flex: 1,
      renderCell: (data) => (
        <>
          <Typography variant='contained' size='small'>
            {data.row.stop_time_override === null || undefined
              ? ''
              : convertDate(data.row.stop_time_override, 0, 17)}
          </Typography>
        </>
      ),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      flex: 1,
      renderCell: (data) => (
        <>
          <Button
            variant='contained'
            size='small'
            onClick={() => {
              setRowData(data.row);
              handleOpen();
            }}
          >
            Edit
          </Button>
        </>
      ),
    },
  ];

  return useType !== 'manager' ? (
    <UnauthorisedAccess />
  ) : (
    <Box style={{ height: '65vh', width: '100%' }}>
      <Box>
        <Grid
          container
          // marginBottom='-10px'
          columnGap={1}
        >
          <Grid xs={12} md={3}>
            <UsersAutocomplete
              nameLabel='Tech Username'
              filterData={(data) => handleFilterChange(data, 'tech_username')}
            />
          </Grid>
          {/* <Grid xs={12} md={3}></Grid> */}
          <Grid xs={12} md={5} container>
            <Grid xs={12} md={3}>
              <DatePicker
                dateLabel='Start Date'
                getDate={(data) =>
                  handleRangeChange(handelDate(data, '00:01:01'), 'start_time')
                }
              ></DatePicker>
            </Grid>
            <Grid xs={12} md={1}></Grid>
            <Grid xs={12} md={3}>
              <DatePicker
                dateLabel='End Date'
                getDate={(data) =>
                  handleRangeChange(handelDate(data, '23:59:59'), 'stop_time')
                }
              ></DatePicker>
            </Grid>
            <Grid xs={12} md={1}></Grid>
            <Grid xs={12} md={4} sx={{ display: 'flex', alignItems: 'center' }}>
              <Button
                variant='outlined'
                size='large'
                onClick={handleClearDateRange}
              >
                Clear
              </Button>
            </Grid>
          </Grid>
          <Grid xs={12} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
            <Button
              variant='contained'
              size='large'
              type='info'
              onClick={() => {
                new ExportToCsv('Time_Attendance_Clocked_Times', {
                  filter: {
                    fullfilter: fullFilterBlob,
                    rangefilter: rangeFilterBlob,
                  },
                }).Download();
              }}
            >
              Extract Data
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Typography
        variant='h6'
        align='center'
        xs={{
          background: '#ebedf8',
          margin: '0 auto',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          flexGrow: 1,
          textAlign: 'center',
          align: 'center',
        }}
      >
        User Clocked In Status
      </Typography>
      <DataGrid
        sx={{ ...gridStyle, maxHeight: '50vh' }}
        rows={loggedData}
        getRowId={(row) => row?.tech_id}
        // rowCount={loggedTotalRows}
        // loading={loading}
        pagination
        // sortingMode='server'
        // filterMode='server'
        onSortModelChange={(model) => {
          // setLoggedPage(0);
          setLoggedSort(model);
        }}
        // onFilterModelChange={(model) => {
        //   setLoggedPage(0);
        //   setLoggedFilter(model.quickFilterValues);
        // }}
        page={loggedPage}
        // pageSize={loggedPageSize}
        // initialState={{
        //   pagination: {
        //     paginationModel: { pageSize: 5, page: 0 },
        //   },
        // }}
        // paginationMode='client'
        onPageChange={(newPage) => {
          setLoggedPage(newPage);
        }}
        onPageSizeChange={(newPageSize) => {
          setLoggedPage(0);
          setLoggedPageSize(newPageSize);
        }}
        columns={clockedInColumns}
        onRowClick={(params) => {}}
        // rowsPerPageOptions={[25, 50, 100]}
        // components={{ Toolbar: CustomCustomerToolbar }}
        autoPageSize
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        componentsProps={
          {
            // getRowId: loggedData.tech_id,
            // toolbar: {
            //   updateOnclick: () => {
            //     setUpdateData((i) => i + 1);
            //   },
            //   filterOnClick: () => {
            //     // handleFilterOpen();
            //   },
            //   // modalState: modalState,
            // },
          }
        }
      />
      <Typography
        variant='h6'
        align='center'
        xs={{
          background: '#ebedf8',
          margin: '0 auto',
          marginTop: '5px !important',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          flexGrow: 1,
          textAlign: 'center',
          align: 'center',
        }}
      >
        Clocked In Times
      </Typography>
      <DataGrid
        sx={{ ...gridStyle, maxHeight: '50vh' }}
        rows={data}
        rowCount={totalRows}
        loading={loading}
        pagination
        sortingMode='server'
        filterMode='server'
        onSortModelChange={(model) => {
          setPage(0);
          setSort(model);
        }}
        onFilterModelChange={(model) => {
          setPage(0);
          setFilter(model.quickFilterValues);
        }}
        page={page}
        pageSize={pageSize}
        paginationMode='server'
        onPageChange={(newPage) => {
          setPage(newPage);
        }}
        onPageSizeChange={(newPageSize) => {
          setPage(0);
          setPageSize(newPageSize);
        }}
        columns={timeColumns}
        onRowClick={(params) => {}}
        onRowDoubleClick={(params) => {
          setRowData(params.row);
          handleOpen();
          // getMyRowData(params.row);
          // setEditOrSave('editMode');
        }}
        rowsPerPageOptions={[25, 50, 100]}
        // components={{ Toolbar: CustomCustomerToolbar }}
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        componentsProps={{
          toolbar: {
            updateOnclick: () => {
              setUpdateData((i) => i + 1);
            },
            filterOnClick: () => {
              // handleFilterOpen();
            },
            // modalState: modalState,
          },
        }}
      />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='parent-modal-Time_Attendance'
        aria-describedby='parent-modal-Time_Attendance_Row_Edit'
      >
        <TimeAndAttendanceEdit thisRowData={rowData} cancelEdit={handleClose} />
      </Modal>
    </Box>
  );
};

export default TimeAndAttendance;

const ticketType = (val) => {
  switch (val) {
    case 'day_start':
      return 'Day Clock';
    case 'repair_ticket':
      return 'Repair Ticket';
    case 'install_ticket':
      return 'Install Ticket';
    default:
      break;
  }
};
